import React, { useState } from "react";
import Warning from "../../UI/Icons/Warning";
import PopupModal from "../../UI/Popup";
import RenewDocumentRequestModal from "./RenewDocumentRequestModal";
import CustomButton from "../../UI/Buttons/CustomButton";

interface CandidateDocumentRenewProps {
  documentName: string;
}

const CandidateDocumentRenew: React.FC<CandidateDocumentRenewProps> = ({
  documentName,
}) => {
  const [showRenewalModal, setShowRenewalModal] = useState<boolean>(false);

  const onClickClose = () => {
    setShowRenewalModal(false);
  }
  return (
    <div className="d-flex">
      <div className="bg-teal-light px-15px py-10px radius-8px gap-6 align-items-center">
        <Warning />
        To update this document please{" "}
        <CustomButton
          className="fw-700 text-black text-decoration-underline cursor-pointer bg-transparent border-0 p-0"
          onClick={() => setShowRenewalModal(true)}
          variant="primary"
        >
          make a request.
        </CustomButton>
      </div>

      <PopupModal
        visible={showRenewalModal}
        showCloseBtn={true}
        onClickClose={onClickClose}
        customWidth={650}
      >
        <RenewDocumentRequestModal documentType={documentName} setShowRenewalModal={setShowRenewalModal}/>
      </PopupModal>
    </div>
  );
};

export default CandidateDocumentRenew;
